export const LOAD_TIME_ZONES = 'LOAD_TIME_ZONES'